import actions from './actions'
import mutations from './mutation'

const state = {
  activeTab: 'overview',
  balance: 0,
  //链下扩容通道管理
  chan_list: [],
  chan_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },

  //链下扩容交易列表
  tx_list: [],
  tx_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },

  //链下扩容通道内交易列表
  chan_tx_list: [],
  chan_tx_paging: {
    offset: 0,
    limit: 10,
    total: 0
  }
}

export default {
  state,
  actions,
  mutations
}
